/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_myteam_signin_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in free to save your team`)
};

const es_f1_myteam_signin_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión gratis para guardar tu equipo`)
};

const de_f1_myteam_signin_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melde dich kostenlos an, um dein Team zu speichern`)
};

const nl_f1_myteam_signin_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meld je gratis aan om je team op te slaan`)
};

const fr_f1_myteam_signin_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous gratuitement pour sauvegarder votre équipe`)
};

const it_f1_myteam_signin_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi gratis per salvare la tua squadra`)
};

const pt_br2_f1_myteam_signin_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre grátis para salvar seu time`)
};

const pt_f1_myteam_signin_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sessão grátis para guardar a tua equipa`)
};

const ja_f1_myteam_signin_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料でサインインしてチームを保存`)
};

const zh_f1_myteam_signin_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费登录以保存你的阵容`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_myteam_signin_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_myteam_signin_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_myteam_signin_title", locale)
	if (locale === "en") return en_f1_myteam_signin_title(inputs)
	if (locale === "es") return es_f1_myteam_signin_title(inputs)
	if (locale === "de") return de_f1_myteam_signin_title(inputs)
	if (locale === "nl") return nl_f1_myteam_signin_title(inputs)
	if (locale === "fr") return fr_f1_myteam_signin_title(inputs)
	if (locale === "it") return it_f1_myteam_signin_title(inputs)
	if (locale === "pt-BR") return pt_br2_f1_myteam_signin_title(inputs)
	if (locale === "pt") return pt_f1_myteam_signin_title(inputs)
	if (locale === "ja") return ja_f1_myteam_signin_title(inputs)
	return zh_f1_myteam_signin_title(inputs)
};